import React from 'react';
import { CompanyDTO, CustomerProfileDTO, LoanFormConfigDTO } from "@/shared/api/model";
import LoanApplicationDocument from './LoanApplicationDocument';

interface SmartLoanApplicationDocumentProps {
    user: any;
    product: any;
    amount: string | undefined;
    period: string | undefined;
    scheduleData: any;
    company: CompanyDTO | undefined;
    feeBreakdown?: any;
    loanBalanceData?: any;
    customerProfile?: CustomerProfileDTO;
    disbursementInstitutionName?: string;
    formConfig?: LoanFormConfigDTO;
}

/**
 * Smart wrapper component that selects the appropriate loan application form
 * based on the product's JSON configuration
 * 
 * Note: Does not use React Query hooks because PDF rendering happens outside
 * the QueryClientProvider context. Config data should be passed as props.
 */
const SmartLoanApplicationDocument: React.FC<SmartLoanApplicationDocumentProps> = (props) => {
    return <LoanApplicationDocument {...props} formConfig={props.formConfig} />;
};

export default SmartLoanApplicationDocument;
